import { memo, useRef } from 'react';

import { useScrollElementContext } from '~/components/v2/components/shared/scroll/ScrollElementContextProvider';
import { PrivateWorkspaceAgentAssetListGalleryView } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListGalleryView';
import { usePrivateWorkspaceAgentAssetListContext } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListProvider';
import { PrivateWorkspaceAgentAssetListTableView } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListTableView';
import { WorkspaceAgentAssetListUnavailableState } from '~/components/v2/components/workspace/workspace-agent-asset-list/WorkspaceAgentAssetListUnavailableState';
import { useWorkspaceAgentAssetListViewStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentAssetListViewStore';

/**
 * No background context menu: the All assets one offers upload and new board, which mean nothing
 * on a snapshot of the agent's results.
 */
export const PrivateWorkspaceAgentAssetListContent = memo(() => {
  const { isError, isWrongType } = usePrivateWorkspaceAgentAssetListContext();
  const presentation = useWorkspaceAgentAssetListViewStore((state) => state.presentation);
  const { scrollElement } = useScrollElementContext();
  const scrollElementRef = useRef<HTMLDivElement | HTMLElement | null>(scrollElement);
  scrollElementRef.current = scrollElement;

  // Retries are already spent (and skipped for a 404/403) by the time the query errors.
  if (isError || isWrongType) {
    return <WorkspaceAgentAssetListUnavailableState />;
  }

  if (!scrollElement) {
    return null;
  }

  if (presentation === 'gallery') {
    return <PrivateWorkspaceAgentAssetListGalleryView scrollElementRef={scrollElementRef} />;
  }

  return <PrivateWorkspaceAgentAssetListTableView scrollElementRef={scrollElementRef} />;
});

PrivateWorkspaceAgentAssetListContent.displayName = 'PrivateWorkspaceAgentAssetListContent';
